import React, { useState } from "react";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import { Link } from "react-router-dom";
import OAuth from "../components/OAuth";
import {
	getAuth,
	createUserWithEmailAndPassword,
	updateProfile,
} from "firebase/auth";
import { db } from "../firebase";
import { serverTimestamp, setDoc, doc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

export default function SignUp() {
	const [showPassword, setShowPassword] = useState(false);
	const [formData, setFormData] = useState({
		name: "",
		email: "",
		password: "",
	});

	const { name, email, password } = formData;
	const navigate = useNavigate();
	function onChange(e) {
		setFormData((prevState) => ({
			...prevState,
			[e.target.id]: e.target.value,
		}));
	}
	async function onSubmit(e) {
		e.preventDefault();
		try {
			const auth = getAuth();
			const userCredential = await createUserWithEmailAndPassword(
				auth,
				email,
				password
			);
			updateProfile(auth.currentUser, {
				displayName: name,
			});
			const user = userCredential.user;
			const formDataCopy = { ...formData };
			delete formDataCopy.password;
			formDataCopy.timestamp = serverTimestamp();
			await setDoc(doc(db, "users", user.uid), formDataCopy);
			navigate("/");
		} catch (error) {
			// console.log(error);
			toast.error("Something went wrong with the registration");
		}
	}
	return (
		<div className="flex flex-wrap flex-col-reverse lg:flex-row items-center py-20">
			<div className="h-full w-full lg:w-1/2 flex items-center justify-center">
				<h1 className="text-8xl font-extralight text-center">
					Parvind's Blog
				</h1>
			</div>
			<div className="text-sm w-full lg:w-1/2 flex items-center text-center justify-center">
				<form
					onSubmit={onSubmit}
					className="w-full mx-4 mb-10"
				>
					<h1 className="font-bold text-xl my-5">Sign Up</h1>
					<input
						className="p-2 mb-4 w-3/4 text-gray-800 bg-gray-200 px-4 py-2 text-lg rounded-md transition ease-in-out"
						type="text"
						id="name"
						value={name}
						onChange={onChange}
						placeholder="Name"
					/>
					<input
						className="p-2 mb-4 w-3/4 text-gray-800 bg-gray-200 px-4 py-2 text-lg rounded-md transition ease-in-out"
						type="email"
						id="email"
						value={email}
						onChange={onChange}
						placeholder="Email Address"
					/>
					<div className="relative mb-4">
						<input
							className="p-2 w-3/4 text-gray-800 bg-gray-200 px-4 py-2 text-lg rounded-md transition ease-in-out"
							type={showPassword ? "text" : "password"}
							id="password"
							value={password}
							onChange={onChange}
							placeholder="Password"
						/>
						{showPassword ? (
							<AiFillEyeInvisible
								className="absolute
                                            right-[15%]
                                            top-4
                                            cursor-pointer"
								onClick={() =>
									setShowPassword((prevState) => !prevState)
								}
							/>
						) : (
							<AiFillEye
								className="absolute
                                            right-[15%]
                                            top-4
                                            cursor-pointer"
								onClick={() =>
									setShowPassword((prevState) => !prevState)
								}
							/>
						)}
					</div>
					<div className="mx-auto flex justify-between w-3/4 text-xs sm:text-sm whitespace-nowrap mb-4">
						<p>
							Already have an account?
							<Link
								className="text-red-500 hover:text-red-600 transition duration-200 ease-in-out ml-1"
								to="/sign-in"
							>
								Sign In
							</Link>
						</p>
						<p>
							<Link
								className="text-blue-500 hover:text-blue-600 transition duration-200 ease-in-out"
								to="/forgot-password"
							>
								Forgot Password?
							</Link>
						</p>
					</div>
					<button className="bg-blue-600 hover:bg-blue-700 w-3/4 p-2 text-white rounded-md shadow-md uppercase font-medium">
						Sign Up
					</button>
					<div className="flex before:flex-1 before:border-t before:border-gray-600 after:flex-1 after:border-t after:border-gray-600 mx-auto my-2 w-3/4 text-center items-center justify-center">
						<p className="mx-2">OR</p>
					</div>
					<OAuth />
				</form>
			</div>
		</div>
	);
}
